import { TaskAction } from "./taskAction";

export interface Automation {
    automationId: number | string;
    code: number | string;
    action: number | string | null;
    models: string | null;
    description?: string;
    triggerType: string | null;
    triggerValue: string | null;
    actionDetails?: TaskAction,
    triggerTypeDetails?: AutomationTrigger,
}

export interface AutomationTrigger {
    code: number | string;
    description: string;
    color: string;
}

export interface AutomationFilter {
    options: {
        triggerType: [],
    },
    cache: {
        triggerType: [],
    },
    values: {
        triggerType?: string,
    },
    applied: {
        triggerType?: string,
    }
}

export function getDefaultAutomation(): Automation {
    return structuredClone({
        automationId: '',
        code: '',
        action: null,
        models: null,
        triggerType: null,
        triggerValue: null,
    })
}